import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isAuthenticated, logout } = useAuth();

  return (
    <nav className="bg-white border-b border-gray-100">
      <div className="px-2 md:px-4">
        <div className="flex justify-between items-center h-16">
          {/* Sol Menü */}
          <div className="flex items-center ml-0">
            <img
              src="/seyfettinLogo.jpg"
              alt="Seyfettin Logo"
              className="w-16 h-16 object-contain rounded bg-white p-1.5 mr-4"
            />
            <Link to="/" className="text-2xl font-bold text-blue-600">
              Zaman Bilimi
            </Link>
          </div>

          {/* Sağ Menü */}
          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/cizelgeler"
              className="text-gray-600 hover:text-blue-600 transition-colors duration-200 font-medium text-lg px-6 py-3 rounded-lg"
            >
              Zaman Çizelgeleri
            </Link>
            {isAuthenticated ? (
              <>
                <Link
                  to="/gosterge-paneli"
                  className="text-gray-600 hover:text-blue-600 transition-colors duration-200 font-medium text-lg px-6 py-3 rounded-lg"
                >
                  Yönetim
                </Link>
                <button
                  onClick={logout}
                  className="px-6 py-3 text-blue-600 hover:text-blue-700 font-medium transition-colors duration-200 text-lg rounded-lg"
                >
                  Çıkış Yap
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/giris"
                  className="px-6 py-3 text-blue-600 hover:text-blue-700 font-medium transition-colors duration-200 text-lg rounded-lg"
                >
                  Giriş Yap
                </Link>
                <Link
                  to="/kayit"
                  className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200 font-medium text-lg"
                >
                  Kayıt Ol
                </Link>
              </>
            )}
          </div>

          {/* Mobil Menü Butonu */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors duration-200"
          >
            <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>

        {/* Mobil Menü Drawer */}
        {isMenuOpen && (
          <div className="fixed inset-0 z-50 lg:hidden">
            {/* Backdrop */}
            <div
              className="absolute inset-0 bg-black bg-opacity-50 transition-opacity"
              onClick={() => setIsMenuOpen(false)}
            ></div>

            {/* Drawer */}
            <div className="absolute top-0 right-0 w-64 h-full bg-white shadow-xl transform transition-transform duration-300 ease-in-out flex flex-col">
              {/* Drawer Header */}
              <div className="flex justify-between items-center p-4 border-b">
                <span className="font-bold text-lg text-gray-800">Menü</span>
                <button
                  onClick={() => setIsMenuOpen(false)}
                  className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              {/* Drawer Content */}
              <div className="flex flex-col p-4 space-y-4 overflow-y-auto">
                <Link
                  to="/cizelgeler"
                  className="text-gray-700 hover:text-blue-600 transition-colors duration-200 font-medium text-lg py-2 border-b border-gray-100"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Zaman Çizelgeleri
                </Link>
                {isAuthenticated ? (
                  <>
                    <Link
                      to="/gosterge-paneli"
                      className="text-gray-700 hover:text-blue-600 transition-colors duration-200 font-medium text-lg py-2 border-b border-gray-100"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      Yönetim
                    </Link>
                    <button
                      onClick={() => {
                        logout();
                        setIsMenuOpen(false);
                      }}
                      className="text-red-600 hover:text-red-700 font-medium text-lg py-2 text-left"
                    >
                      Çıkış Yap
                    </button>
                  </>
                ) : (
                  <div className="flex flex-col space-y-3 pt-2">
                    <Link
                      to="/giris"
                      className="text-gray-700 hover:text-blue-600 font-medium text-lg py-2 border-b border-gray-100"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      Giriş Yap
                    </Link>
                    <Link
                      to="/kayit"
                      className="bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200 font-medium px-4 py-3 text-center mt-2"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      Kayıt Ol
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation; 